import { Theme } from "@aws-amplify/ui-react"

/**
 * @description
 *	Configuration of the theme for the entire application.
 *
 * @remarks
 *	The accent of the integration is read from the custom properties, which
 *	are declared above this theme by the branded theme provider: a var()
 *	written inside a token is emitted as is, so it resolves against the
 *	ancestors of the element of the theme.
 *
 *	The font tokens are the only way to reach the whole application: the
 *	stylesheet of Amplify sets the font family on its own theme element, so a
 *	class on the html element is not enough.
 *
 * @see https://ui.docs.amplify.aws/react/theming
 */
const BiometryTheme: Theme = {
	name: "Biometry",
	tokens: {
		fonts: {
			default: {
				static: { value: "var(--font-poppins)" },
				variable: { value: "var(--font-poppins)" }
			}
		},
		colors: {
			primary: {
				80: { value: "var(--amplify-colors-white)" }
			},
			background: { primary: { value: "var(--sanii-surface)" } }
		},
		components: {
			button: {
				borderRadius: { value: "50px" },
				// The accent arrives once the branding answers, and the
				// default of Amplify is 250ms: the button fades into it at
				// the same speed as the rest of the landing.
				transitionDuration: { value: "150ms" },
				_hover: {
					color: { value: "grey" }
				},
				link: {
					color: { value: "black" },
					_hover: {
						color: { value: "darkgray" }
					}
				},
				primary: {
					backgroundColor: { value: "var(--sanii-accent)" },
					borderColor: { value: "transparent" },
					color: { value: "var(--sanii-on-accent)" },
					_hover: {
						backgroundColor: { value: "var(--sanii-accent)" },
						color: { value: "var(--sanii-on-accent)" }
					},
					_active: {
						backgroundColor: { value: "var(--sanii-accent)" },
						color: { value: "var(--sanii-on-accent)" }
					},
					_focus: {
						backgroundColor: { value: "var(--sanii-accent)" },
						color: { value: "var(--sanii-on-accent)" }
					}
				}
			}
		}
	}
}

export default BiometryTheme
